import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminsGuard implements CanActivate {


  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    const accessToken = localStorage.getItem('BIO2_AccessToken');

    if (accessToken) {
      const decodedToken = this.authService.getDecodedAccessToken(accessToken);
      const role = decodedToken['role'];
      const registoId = decodedToken['registoId']; 

      if (role === 'Administrador' && environment.allowedAdminIds.includes(registoId)) {
        return true;
      }
    }

    // If not allowed, redirect to login
    this.router.navigate(['/login']);
    return false;
  }
}